export default "__VITE_ASSET__BS0cb6uD__"